import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import api from "@/lib/api";

export default function NotificationBell() {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const nav = useNavigate();

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/notifications");
      setItems(data.items || []);
      setUnread(data.unread || 0);
    } catch {}
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, [load]);

  const markRead = async (id) => {
    try { await api.post(`/notifications/${id}/read`); } catch {}
    load();
  };
  const readAll = async () => {
    try { await api.post("/notifications/read-all"); } catch {}
    load();
  };

  return (
    <div className="relative" data-testid="notification-bell">
      <button
        onClick={() => setOpen((v) => !v)}
        className="dt6-btn text-xs relative"
        title="Notifications"
        data-testid="notification-bell-toggle"
      >
        <Bell size={14} />
        {unread > 0 && (
          <span
            className="absolute -top-1 -right-1 font-mono text-[0.6rem] px-1 py-[1px]"
            style={{ background: "var(--dt6-secondary)", color: "#0B0E14", borderRadius: 2 }}
            data-testid="notification-badge"
          >
            {unread}
          </span>
        )}
      </button>
      {open && (
        <div
          className="absolute right-0 mt-2 w-96 dt6-card p-0 z-50"
          style={{ background: "var(--dt6-surface)" }}
          data-testid="notification-panel"
        >
          <div className="px-4 py-3 flex items-center justify-between border-b" style={{ borderColor: "var(--dt6-border)" }}>
            <div className="font-mono text-[0.7rem] tracking-[0.14em] uppercase text-[color:var(--dt6-muted)]">/ NOTIFICATIONS</div>
            {unread > 0 && <button className="text-xs dt6-link" onClick={readAll} data-testid="notification-read-all">mark all read</button>}
          </div>
          <div className="max-h-96 overflow-y-auto">
            {items.length === 0 ? (
              <div className="p-6 text-center text-xs font-mono tracking-[0.14em] text-[color:var(--dt6-muted)]" data-testid="notification-empty">
                NO NOTIFICATIONS YET.
              </div>
            ) : items.map((n) => (
              <button
                key={n.id}
                onClick={() => { markRead(n.id); if (n.action_url) nav(n.action_url); setOpen(false); }}
                className={`w-full text-left px-4 py-3 border-b hover:bg-[color:var(--dt6-surface-2)] ${n.read ? "opacity-60" : ""}`}
                style={{ borderColor: "var(--dt6-border)" }}
                data-testid={`notification-item-${n.id}`}
              >
                <div className="flex items-start gap-2">
                  <div className={`mt-1 w-2 h-2 rounded-full ${n.read ? "bg-transparent border border-[color:var(--dt6-border-2)]" : n.critical ? "bg-[color:var(--dt6-danger)]" : "bg-[color:var(--dt6-primary)]"}`} />
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium truncate">{n.title}</div>
                    <div className="text-xs text-[color:var(--dt6-muted)] mt-0.5">{n.body}</div>
                    <div className="text-[0.65rem] font-mono text-[color:var(--dt6-muted)] mt-1">
                      {new Date(n.created_at).toLocaleString()} · <span className="uppercase">{n.kind}</span>
                    </div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
